export default {
  items: state => state.items,
  item: state => team_id => state.items.find(item => item.team_id === team_id),
  sort: state => state.sort,
  more: state => state.more,
  loading: state => state.loading,
  total: state => state.total,
};
